<template>
  <div class="chain-report-container">
    <div class="report-header">
      <div class="report-tabs">
        <button class="tab-btn active">五大行业经营情况</button>
        <button class="tab-btn">业务链群经营情况</button>
      </div>
      <div class="report-info">
        <div class="report-date">更新至 2026-07-24</div>
        <button class="report-action">编辑报告</button>
      </div>
    </div>

    <div class="chain-summary">
      <div class="summary-title">业务链群经营情况</div>
      <div class="summary-stats">
        <div class="summary-stat">
          <span class="stat-label">营收规模</span>
          <span class="stat-value">346,258 万</span>
        </div>
        <div class="summary-stat">
          <span class="stat-label">同比增长</span>
          <span class="stat-value green">12.8%</span>
        </div>
        <div class="summary-stat">
          <span class="stat-label">重点关差</span>
          <span class="stat-value warning">2 个链群</span>
        </div>
        <div class="summary-stat">
          <span class="stat-label">目标达成率</span>
          <span class="stat-value">97.9%</span>
        </div>
      </div>
    </div>

    <div class="report-section">
      <div class="section-header">
        <div class="section-title">智能制造链群</div>
        <div class="section-badge">
          <span class="badge-text">14,760 万</span>
          <span class="badge-value">31.3%</span>
        </div>
      </div>

      <div class="sub-section">
        <div class="sub-title">H1 百万级客户成交清单</div>
        <div class="sub-table">
          <table>
            <thead>
              <tr>
                <th>客户</th>
                <th>成交金额</th>
                <th>合作内容</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>某家电集团</td>
                <td>1,700 万</td>
                <td>智能工厂整体解决方案</td>
              </tr>
              <tr>
                <td>某汽车零部件集团（津）</td>
                <td>2,980 万</td>
                <td>数字化车间、智能制造解决方案工厂</td>
              </tr>
              <tr>
                <td>某智能装备客户（沪）</td>
                <td>6,000 万</td>
                <td>智能工厂整体解决方案、智能制造能力中台</td>
              </tr>
              <tr>
                <td>某重工集团（鲁）</td>
                <td>5,740 万</td>
                <td>智能产线、智能仓储与物流自动化</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="sub-section">
        <div class="sub-title">H1 百万级客户丢单清单</div>
        <div class="sub-table">
          <table>
            <thead>
              <tr>
                <th>客户</th>
                <th>丢单金额</th>
                <th>丢单原因</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>A企</td>
                <td>5,470 万</td>
                <td>方案验证周期长</td>
              </tr>
              <tr>
                <td>某汽车零部件集团（津）</td>
                <td>1,380 万</td>
                <td>价格竞争与客户降本压力</td>
              </tr>
              <tr>
                <td>某智能装备客户（沪）</td>
                <td>1,100 万</td>
                <td>交付周期及海外认证复杂</td>
              </tr>
              <tr>
                <td>某重工集团（鲁）</td>
                <td>6,000 万</td>
                <td>客户投资、审批或预算延后</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="sub-section">
        <div class="sub-title">H2 百万级客户拓展清单</div>
        <div class="sub-table">
          <table>
            <thead>
              <tr>
                <th>客户</th>
                <th>预计金额</th>
                <th>预计签约时间</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>B企</td>
                <td>18,000 万</td>
                <td>2026-08-15</td>
              </tr>
              <tr>
                <td>某汽车零部件集团（津）</td>
                <td>5,800 万</td>
                <td>2026-08-31</td>
              </tr>
              <tr>
                <td>某智能装备客户（沪）</td>
                <td>7,100 万</td>
                <td>2026-09-15</td>
              </tr>
              <tr>
                <td>某重工集团（鲁）</td>
                <td>6,500 万</td>
                <td>2026-09-30</td>
              </tr>
              <tr>
                <td>某家电集团（粤）</td>
                <td>8,200 万</td>
                <td>2026-10-15</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="report-footer">
      <div class="footer-note">注：数据截至 2026 年 6 月 30 日，部分数据为预估。</div>
      <div class="footer-action">查看更多详情</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChainReport'
}
</script>

<style scoped>
.chain-report-container {
  padding: 20px;
  background: #ffffff;
  border-radius: 16px;
  border: 1px solid #e8ecf0;
  min-height: 100%;
}

.report-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
}

.report-tabs {
  display: flex;
  gap: 8px;
}

.tab-btn {
  padding: 6px 14px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  border: 1px solid #e8ecf0;
  background: #f8fafc;
  color: #64748b;
  cursor: pointer;
  transition: all 0.2s;
}

.tab-btn.active {
  background: #4a5ff3;
  color: #ffffff;
  border-color: #4a5ff3;
}

.report-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.report-date {
  font-size: 12px;
  color: #94a3b8;
}

.report-action {
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 11px;
  color: #4a5ff3;
  background: #f0f4ff;
  border: 1px solid #dde4f0;
  cursor: pointer;
}

.chain-summary {
  padding: 16px;
  border-radius: 12px;
  background: linear-gradient(135deg, rgba(74, 95, 243, 0.08), rgba(74, 95, 243, 0.03));
  border: 1px solid rgba(74, 95, 243, 0.15);
  margin-bottom: 20px;
}

.summary-title {
  font-size: 14px;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 12px;
}

.summary-stats {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}

.summary-stat {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.summary-stat .stat-label {
  font-size: 11px;
  color: #64748b;
}

.summary-stat .stat-value {
  font-size: 16px;
  font-weight: 700;
  color: #1f2937;
}

.summary-stat .stat-value.green {
  color: #0aa66a;
}

.summary-stat .stat-value.warning {
  color: #d98213;
}

.report-section {
  margin-bottom: 20px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.section-title {
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
}

.section-badge {
  display: flex;
  align-items: center;
  gap: 8px;
}

.badge-text {
  font-size: 12px;
  color: #64748b;
}

.badge-value {
  font-size: 14px;
  font-weight: 700;
  color: #0aa66a;
}

.sub-section {
  margin-bottom: 16px;
}

.sub-title {
  font-size: 12px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 8px;
}

.sub-table {
  border-radius: 10px;
  border: 1px solid #e8ecf0;
  overflow: hidden;
}

.sub-table table {
  width: 100%;
  border-collapse: collapse;
}

.sub-table th {
  padding: 8px 10px;
  text-align: left;
  font-size: 11px;
  color: #64748b;
  font-weight: 600;
  background: #f8fafc;
  border-bottom: 1px solid #e8ecf0;
}

.sub-table td {
  padding: 8px 10px;
  font-size: 11px;
  color: #475569;
  border-bottom: 1px solid #f1f5f9;
}

.report-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 12px;
  border-top: 1px solid #f1f5f9;
}

.footer-note {
  font-size: 11px;
  color: #94a3b8;
}

.footer-action {
  font-size: 12px;
  color: #4a5ff3;
  font-weight: 600;
  cursor: pointer;
}
</style>
